import React from 'react';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { Stack } from '@cp/ds/src/components/stack';
import { CitySearchFormField } from '@cp/entities/location';
import { LocationIcon } from '@cp/ds/src/icons';
import { SortButton } from 'src/entities/catalog/nav/resume/ui/sortButton';
import { CatalogNavResumeViewProps } from './model';

const ViewDesktop: React.FC<CatalogNavResumeViewProps> = ({ sx }) => {
  const containerSx = React.useMemo(
    () =>
      mergeSx(
        {
          width: '100%',
          alignItems: 'flex-start',
        },
        sx,
      ),
    [sx],
  );

  return (
    <Stack component="form" gap={1.5} noValidate sx={containerSx}>
      <CitySearchFormField
        endAdornment={<LocationIcon fontSize="1rem" />}
        fieldContainerProps={{ sx: { width: '100%' } }}
        placeholder="Поиск города..."
        size="small"
      />
      <SortButton />
    </Stack>
  );
};

export default ViewDesktop;
